import * as Yup from 'yup'

export const signInSchemaValidation = Yup.object().shape({
    username: Yup.string().email('Invalid email').required('Required'),
    password: Yup.string().min(6, 'Password too short').matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*]).*$/, 'Incorrect password or username')
    .required('Password is required'),
})